import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Box,
  Button,
} from '@mui/material';
import { useAuthStore } from '../stores/authStore';
import { useNavigate } from 'react-router-dom';
import {
  School,
  LibraryBooks,
  Assessment,
  Person,
} from '@mui/icons-material';

const Dashboard: React.FC = () => {
  const { user } = useAuthStore();
  const navigate = useNavigate();

  const menuItems = [
    {
      title: 'Terminology',
      description: 'Browse and manage terminology',
      icon: <LibraryBooks sx={{ fontSize: 40 }} />,
      path: '/terminology',
      color: '#2196f3',
    },
    {
      title: 'Learning',
      description: 'Access learning materials',
      icon: <School sx={{ fontSize: 40 }} />,
      path: '/learning',
      color: '#4caf50',
    },
    {
      title: 'Analytics',
      description: 'View learning analytics',
      icon: <Assessment sx={{ fontSize: 40 }} />,
      path: '/analytics',
      color: '#ff9800',
    },
    {
      title: 'Profile',
      description: 'Manage your profile',
      icon: <Person sx={{ fontSize: 40 }} />,
      path: '/profile',
      color: '#9c27b0',
    },
  ];

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Welcome to the Multi-Lingual Learning Platform
      </Typography>

      <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
        Hello {user?.full_name || user?.username}! Role: {user?.role}
      </Typography>

      <Grid container spacing={3}>
        {menuItems.map((item) => (
          <Grid item xs={12} sm={6} md={3} key={item.title}>
            <Card
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                cursor: 'pointer',
                transition: 'transform 0.2s',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: 3,
                },
              }}
              onClick={() => navigate(item.path)}
            >
              <CardContent sx={{ flexGrow: 1, textAlign: 'center' }}>
                <Box
                  sx={{
                    color: item.color,
                    mb: 2,
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  {item.icon}
                </Box>
                <Typography variant="h6" component="h2" gutterBottom>
                  {item.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {item.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Box sx={{ mt: 4, textAlign: 'center' }}>
        <Typography variant="body1" color="text.secondary">
          Start exploring the platform by clicking on any of the cards above.
        </Typography>
      </Box>
    </Container>
  );
};

export default Dashboard;